import { Box, Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const TransactionDetailsFallback = () => {
    return (
        <HeaderFallback title="جزئیات تسویه حساب">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 2,
                }}>
                <Skeleton variant="rectangular" height="550px" />
                <Skeleton variant="rectangular" height="200px" />
            </Box>
        </HeaderFallback>
    );
};

export default TransactionDetailsFallback;
